module.exports = __webpack_public_path__ + "img/logo.b9dff982.png";